import React from "react";
import { Spinner } from "react-bootstrap";
import { theme } from "../../../styles/theme";

export const LoadingScreen = (): JSX.Element => (
  <div className="d-flex justify-content-center vh-100 align-items-center" style={{ backgroundColor: theme.colors.blue900 }}>
    <Spinner animation="grow" variant="primary" />
  </div>
);